import React, { useEffect, useState } from 'react'
import { Modal, Checkbox, Select, message } from 'antd';
import { features } from '../features/features';
import { useDispatch } from 'react-redux';
const { Option } = Select;

function SelectDateTableRule({ setModalState, currentUrlId, contractAuthKey, contractData }) {
    const dispatch = useDispatch();
    const [checkboxes, setCheckboxes] = useState({
        excludeWeekends: true,
        excludeHolidays: true,
        excludeSpecificDay: false,
    });
    const [selectedDays, setSelectedDays] = useState([]);

    const handleCheckboxChange = (key, checked) => {
        setCheckboxes((prev) => ({ ...prev, [key]: checked }));
        if (key === 'excludeSpecificDay' && !checked) {
            setSelectedDays([]);
        }
    };

    useEffect(() => {
        const selectedRulesForDateTable = JSON.parse(localStorage.getItem(currentUrlId))?.selectedRulesForDateTable || null;
        if (selectedRulesForDateTable && Object.keys(selectedRulesForDateTable).length) {
            if (selectedRulesForDateTable?.excludeWeekends === true) {
                setCheckboxes((prev) => ({ ...prev, excludeWeekends: true }));
            } else if (selectedRulesForDateTable?.excludeWeekends === false) {
                setCheckboxes((prev) => ({ ...prev, excludeWeekends: false }));
            }

            if (selectedRulesForDateTable?.excludeHolidays === true) {
                setCheckboxes((prev) => ({ ...prev, excludeHolidays: true }));
            } else if (selectedRulesForDateTable?.excludeHolidays === false) {
                setCheckboxes((prev) => ({ ...prev, excludeHolidays: false }));
            }

            if (selectedRulesForDateTable?.excludeSpecificDay?.length > 0) {
                setCheckboxes((prev) => ({ ...prev, excludeSpecificDay: true }));
                setSelectedDays((prev) => [...prev, ...selectedRulesForDateTable?.excludeSpecificDay]);
            } else if (selectedRulesForDateTable?.excludeSpecificDay?.length === 0) {
                setCheckboxes((prev) => ({ ...prev, excludeSpecificDay: false }));
                setSelectedDays([]);
            }
        }
    }, []);
    

    const daysOfWeekOptions = [
        { label: 'Monday', value: 'Monday' },
        { label: 'Tuesday', value: 'Tuesday' },
        { label: 'Wednesday', value: 'Wednesday' },
        { label: 'Thursday', value: 'Thursday' },
        { label: 'Friday', value: 'Friday' },
        { label: 'Saturday', value: 'Saturday' },
        { label: 'Sunday', value: 'Sunday' },
    ];

    const handleApply = () => {
        const { excludeWeekends, excludeHolidays } = checkboxes;
        const weekdays = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'];
        const weekends = ["Saturday", "Sunday"];
        const allDays = daysOfWeekOptions.map(day => day.value);

        const allWeekdaysSelected = weekdays.every((day) => selectedDays.includes(day));
        const onlyWeekendsSelected = selectedDays.length > 0 && selectedDays.every((day) => weekends.includes(day));

        if (excludeWeekends && onlyWeekendsSelected) {
            message.error("Saturday and Sunday are already selected.");
            return;
        }

        if (excludeWeekends && allWeekdaysSelected) {
            message.error("You cannot exclude Monday to Friday when weekends are also excluded.");
            return;
        }

        // **Validation: Prevent selecting all days**
        if (selectedDays.length === allDays.length) {
            message.error("You cannot exclude all 7 days.");
            return;
        }

        if (excludeWeekends && selectedDays.length === weekdays.length && weekdays.every(day => selectedDays.includes(day))) {
            message.error("You cannot exclude Monday to Friday when weekends are also excluded.");
            return;
        }

        let dataToSet = {
            excludeWeekends,
            excludeHolidays,
            excludeSpecificDay: selectedDays,
        };
        
        // save the rule inside the td
        
        const localData = JSON.parse(localStorage.getItem(currentUrlId)) || {};
        Object.assign(localData, {selectedRulesForDateTable: dataToSet});
        localStorage.setItem(currentUrlId, JSON.stringify(localData));
        const selectedRulesForDateTable = JSON.parse(localStorage.getItem(currentUrlId))?.selectedRulesForDateTable || null;
        if (selectedRulesForDateTable && Object.keys(selectedRulesForDateTable).length) {
            features.autoFillDateLogic({
                currentUrlId, 
                source: "MODIFY_DATE_TABLE_RULE",
                selectedRulesForDateTable,
                contractAuthKey,
                dispatch,
                contractData
            });
        }
        
        
        //     specificData: { selectedRulesForDateTable: dataToSet }
        setModalState(prevState => ({ ...prevState, openSelectRuleModal: false }));
    };

    const handleCancel = () => {
        setModalState(prevState => ({ ...prevState, openSelectRuleModal: false }))
    }

    return (
        <div>
            <Modal
                visible={true}
                title={<div className='commonModalTitle'>Select Rule</div>}
                okText="Apply"
                onCancel={() => handleCancel()}
                onOk={() => handleApply()}
                okButtonProps={{ disabled: checkboxes.excludeSpecificDay && selectedDays.length === 0 }}

            >
                {/* Checkbox for "Exclude Weekends" */}
                <div style={{ marginBottom: 8 }}>
                    <Checkbox
                        checked={checkboxes.excludeWeekends}
                        onChange={(e) => handleCheckboxChange('excludeWeekends', e.target.checked)}
                    >
                        Exclude Weekends
                    </Checkbox>
                </div>
                {/* Checkbox for "Exclude Holidays" */}
                <div style={{ marginBottom: 8 }}>
                    <Checkbox
                        checked={checkboxes.excludeHolidays}
                        onChange={(e) => handleCheckboxChange('excludeHolidays', e.target.checked)}
                    >
                        Exclude Holidays
                    </Checkbox>
                </div>
                {/* Checkbox for "Exclude a Specific Day" */}
                <div style={{ marginBottom: 8 }}>
                    <Checkbox
                        checked={checkboxes.excludeSpecificDay}
                        onChange={(e) => handleCheckboxChange('excludeSpecificDay', e.target.checked)}
                    >
                        Exclude Specific Day
                    </Checkbox>
                </div>
                {/* Multiple select UI appears when "Exclude a Specific Day" is checked */}
                {checkboxes.excludeSpecificDay && (
                    <div style={{ marginTop: 16 }}>
                        <Select
                            mode="multiple"
                            placeholder="Select days of week"
                            value={selectedDays}
                            onChange={setSelectedDays}
                            style={{ width: '100%' }}
                            allowClear
                        >
                            {daysOfWeekOptions.map((option) => (
                                <Option key={option.value} value={option.value}>
                                    {option.label}
                                </Option>
                            ))}
                        </Select>
                    </div>
                )}
            </Modal>
        </div>
    )
}

export default SelectDateTableRule